// gamePhaseConfig

const gamePhaseConfig = {
    COUNTDOWN: 'COUNTDOWN',                           // Countdown before freeplay
    FREEPLAY: 'FREEPLAY',                             // Async simultaneous play
    TURN_BASED_SELECT : 'TURN_BASED_SELECT',          // Waiting for player to select hole
    TURN_BASED_SOWING : 'TURN_BASED_SOWING'           // Player is sowing seeds
}

export default gamePhaseConfig;